export default __webpack_public_path__ + "static/media/icon_reports.d817520f.svg";